// frontend/src/auth.js
// Token storage utility — supports "remember me" (localStorage) vs session-only (sessionStorage)

const REMEMBER_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

export function setAuth(data, rememberMe) {
  const { token, username, isAdmin, groupId, groupName, isDefaultGroup } = data
  // username/isAdmin always in localStorage — read by many components as localStorage.getItem(...)
  localStorage.setItem('username', username)
  localStorage.setItem('isAdmin', isAdmin ? 'true' : 'false')
  localStorage.setItem('groupId', groupId != null ? String(groupId) : '')
  localStorage.setItem('groupName', groupName || '')
  localStorage.setItem('isDefaultGroup', isDefaultGroup !== false ? 'true' : 'false')

  if (rememberMe) {
    localStorage.setItem('token', token)
    localStorage.setItem('tokenExpiry', String(Date.now() + REMEMBER_MS))
    sessionStorage.removeItem('token')
  } else {
    sessionStorage.setItem('token', token)
    localStorage.removeItem('token')
    localStorage.removeItem('tokenExpiry')
  }
}

export function getToken() {
  // Session-only check first
  const sessToken = sessionStorage.getItem('token')
  if (sessToken) return sessToken

  // Remember-me check with expiry
  const lsToken = localStorage.getItem('token')
  if (!lsToken) return null

  const expiry = parseInt(localStorage.getItem('tokenExpiry') || '0', 10)
  if (expiry && Date.now() > expiry) {
    localStorage.removeItem('token')
    localStorage.removeItem('tokenExpiry')
    return null
  }
  return lsToken
}

export function clearAuth() {
  sessionStorage.removeItem('token')
  localStorage.removeItem('token')
  localStorage.removeItem('tokenExpiry')
  localStorage.removeItem('username')
  localStorage.removeItem('isAdmin')
  localStorage.removeItem('groupId')
  localStorage.removeItem('groupName')
  localStorage.removeItem('isDefaultGroup')
}
